import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LicenceService } from '../../core/services/licence.service';
import { ValidKey } from '../../core/models/key.model';

@Component({
  selector: 'app-licence-modal',
  templateUrl: './licence-modal.component.html'
})
export class LicenceModalComponent {
  licenceKey: string = '';
  error: string = '';
  success: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private licenceService: LicenceService
  ) {}

  verifyLicence(): void {
    if (this.licenceService.verifyLicenceKey(this.licenceKey as ValidKey)) {
      this.success = 'Licence activée avec succès !';
      this.error = '';
      setTimeout(() => this.activeModal.close('success'), 1500);
    } else {
      this.error = 'Clé de licence invalide';
      this.success = '';
    }
  }
} 